export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return [ "idCard" ].includes(
                    field?.key
                );
            },
            inputPropField: ({ data, modelRef }) => {
                return {
                    "onUpdate:value": value => {
                        modelRef.idCard = value;
                        modelRef.username = value
                    },
                    disabled: data.current > 0 ? true : false
                };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refTitle","birthDate","refNationality","refRace","refGender", "expireDate",
                    "firstNameTh","email","lastNameTh","mobile","refDepartment","addresses.0.noTh",
                    "refSubDepartment","positionCode","refPosition","idLine","refEducation","refMainOccupation","refSecondOccupation","refSameAddressType",
                    "addresses.0.noTh",
                    "addresses.0.soiTh",
                    "addresses.0.roadTh",
                    "addresses.0.mooTh",
                    "addresses.0.refProvince",
                    "addresses.0.refAmphur",
                    "addresses.0.refTambon",
                    "addresses.0.postCode",
                    "addresses.1.noTh",
                    "addresses.1.soiTh",
                    "addresses.1.roadTh",
                    "addresses.1.mooTh",
                    "addresses.1.refProvince",
                    "addresses.1.refAmphur",
                    "addresses.1.refTambon",
                    "addresses.1.postCode",
                    "password","passwordConfirm"
                ].includes(
                    field?.key
                );
            },
            inputPropField: ({ data }) => {
                return data.current > 0 ? { disabled: true } : {};
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refPersonType",
                    "refCompanyType",
                    "companyNameTh",
                    "registerDate",
                    "registerCapital",
                    "addresses.0.tel",
                    "addresses.0.fax",
                    "addresses.0.email",
                    "addresses.1.tel",
                    "addresses.1.fax",
                    "addresses.1.email",
                    "buttonLinkUser",
                    "userRoleRequests",
                    "refRegisterRole",
                    "shareholdingTh"
                ].includes(field?.key);
            },
            visibleField: () => {
                return false
            }
        },
        {
            check: ({ field }) => {
                return [
                    "spaceIdCard"
                ].includes(field?.key);
            },
            visibleField: () => {
                return true;
            },
        },
        {
            check: ({ field }) => {
                return [
                    "addresses.0.refAddressType",
                    "addresses.1.refAddressType"
                ].includes(
                    field?.key
                );
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "acceptCondition",
                    "labelAcceptCondition"
                ].includes(field?.key);
            },
            visibleField: ({ data }) => {
                return data.current === 1;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "attachmentImageSignatures.0"
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.attachmentSignatures?.[0]?.blob != null;
            },
        },
        {
            check: ({ field }) => {
                return [
                    "attachmentImageIdCards.0"
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.attachmentIdCards?.[0]?.blob != null;
            },
        },
        {
            check: ({ field }) => {
                return [
                    "sameAddressType"
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                if(!["1"].includes(modelRef.refSameAddressType?.key)){
                    return true;
                }
                return false
            }
        },
    ];
};
